import { defineStore } from 'pinia'
import { api } from '@/plugins/api'

const locationDefault = {
  firm: null,
  parent: null,
  parentName: 'Invoices AI',
  firmName: '',
  firmId: null,
  firmNumber: null,
  firmType: null,
  isInactive: false,
  postalCode: null
}

export const locationStore = defineStore('location', {
  state: () => ({
    location: JSON.parse(JSON.stringify(locationDefault)),
    locations: [],
    locationTree: [],
    parentLocation: null,
    addLocation: JSON.parse(JSON.stringify(locationDefault)),
    children: [],
    loading: {
      location: false,
      locations: false,
      advancedLocations: false,
      children: false,
      users: false,
      locationTree: false,
      findingLocations: false,
      log: false
    },
    listParams: {
      page: 1,
      pageSize: 10,
      filterOptions: null,
      filterBy: null,
      sortBy: 'asc',
      orderBy: 'Firm',
      searchTerm: ''
    },
    foundFirm: null,
    userSearchTerm: '',
    foundFirmUsers: null,
    foundLocations: [],
    advancedLocations: [],
    log: [],
    preferences: [],
    stripeCustomer: null,
    stripeSubscriptions: null,
    stripeInvoices: null,
    stripeInvoiceReport: null
  }),
  actions: {
    setListParam(data) {
      this.listParams[data.name] = data.value
    },
    setLoading(data) {
      this.loading[data.name] = data.value
    },
    resetLocation() {
      this.stripeCustomer = null
      this.stripeSubscriptions = null
      this.stripeInvoices = null
      this.stripeInvoiceReport = null
      this.location = JSON.parse(JSON.stringify(locationDefault))
    },
    setLocation(data) {
      this.location[data.name] = data.value
    },
    setAddMember(data) {
      this.addMember[data.name] = data.value
    },
    setAddLocation(data) {
      this.addLocation[data.name] = data.value
    },
    resetAddLocation() {
      this.addLocation = JSON.parse(JSON.stringify(locationDefault))
    },
    resetFoundLocations() {
      this.foundLocations = []
    },
    setUserContact(data) {
      this.location.userId = data.user
      this.userSearchTerm = null
      if (data.firstname) {
        this.userSearchTerm = `${data.lastname}, ${data.firstname}`
      } else {
        this.userSearchTerm = data.lastname
      }
    },
    setApp(data) {
      if (data) {
        let found = this.apps.find((x) => parseInt(x.app) === parseInt(data.app))
        if (found) {
          found.firm = data.firm
          found.portalUrl = data.portalUrl
          found.apiUrl = data.apiUrl
        }
      }
    },
    setOnboardLocation(data) {
      this.location = data
    },
    setUserSearchTerm(data) {
      this.userSearchTerm = data
      this.foundFirmUsers = []
    },
    flattenTree(tree) {
      let result = []
      if (tree.name && tree.id) {
        result.push({ name: tree.name, id: tree.id })
      }
      if (tree.members) {
        tree.members.forEach((child) => {
          result = result.concat(this.flattenTree(child))
        })
      }
      return result
    },
    async getLocation(id) {
      this.resetLocation()
      this.members = []
      this.loading.location = true
      this.location = await api.get(`firm/firm?firm=${id}`)
      this.loading.location = false
      if (this.location.parent) {
        this.parentLocation = JSON.parse(this.location.parent)
        this.location.parent = this.parentLocation.firm
      }
      this.userSearchTerm = null
      if (this.location.user) {
        let user = JSON.parse(this.location.user)
        if (user) {
          this.location.userId = user.user
          if (user.firstname) {
            this.userSearchTerm = `${user.lastname}, ${user.firstname}`
          } else {
            this.userSearchTerm = user.lastname
          }
        }
      }
      console.log('Got Location', this.location)
      return this.location
    },
    async getLocationTree(data) {
      this.locationTree = []
      this.advancedLocations = []
      this.locations = []
      this.loading.locationTree = true
      this.locationTree = await api.get(`firm/locationTree?firm=${data.firm}&showInactive=${data.showInactive}&forWhat=${data.for}`)
      this.loading.locationTree = false
      console.log('Got Location Tree', {
        tree: this.locationTree,
        locations: this.locations
      })
      return this.locationTree
    },
    async saveNewLocation() {
      return await api.post('firm/createFirm', this.addLocation)
    },
    async saveLocation() {
      return await api.post('firm/saveFirm', this.location)
    },
    async deleteLocation(data) {
      return await api.post('firm/deleteFirms', data)
    },
    async getChildren(firm) {
      this.children = []
      this.loading.children = true
      this.children = await api.get(`firm/childFirms?firm=${firm}`)
      this.loading.children = false
      console.log('Got Children', this.children)
      return this.children
    },
    async searchFirmUser(search) {
      this.loading.users = true
      this.foundFirmUsers = await api.get('firm/searchFirmUser', search)
      this.loading.users = false
      return this.foundFirmUsers
    },
    async searchLocations(options) {
      this.loading.findingLocations = true
      this.foundLocations = await api.get(`firm/searchFirms?search=${options.search}&type=${options.type}&firm=${options.firm}`)
      this.loading.findingLocations = false
      return this.foundLocations
    },
    async searchAdvanced(options) {
      this.loading.advancedLocations = true
      this.advancedLocations = await api.get('firm/searchFirms', options)
      this.loading.advancedLocations = false
      return this.advancedLocations
    },
    async pushLocation(data) {
      await api.post('data/pushLocationTree', data)
    },
    async moveLocation(data) {
      return await api.post('firm/moveFirm', data)
    },
    async getLog(data) {
      this.loading.log = true
      this.log = await api.get('data/log', data)
      this.loading.log = false
      console.log('Got Log', this.log)
      return this.log
    },
    exportLocations(firm) {
      console.log('Export Locations', firm)
    },
    exportUsers(firm) {
      console.log('Export Users', firm)
    },
    async getPreferences(data) {
      this.preferences = []
      let response = await api.get('firm/preferences', data)
      if (response) {
        if (response !== '') {
          if (Array.isArray(response)) {
            response.forEach((element) => {
              element.changed = false
              let found = false
              for (var i = 0; i < this.preferences.length; i++) {
                if (this.preferences[i].name === element.name && this.preferences[i].type === element.type) {
                  found = true
                  this.preferences[i].value = element.value
                  break
                }
              }
              if (!found) {
                this.preferences.push(element)
              }
            })
          } else {
            this.preferences.push(response)
          }
        }
      }
      console.log('Got Preferences', this.preferences)
      return this.preferences
    },
    resetPreferences() {
      this.preferences = []
    },
    setPreference(data) {
      let found = this.preferences.find((x) => x.name === data.name && x.type === data.type)
      if (found) {
        found.changed = true
        found.firm = data.firm
        if (data.isInactive) {
          found.isInactive = data.isInactive
        }
        found.value = data.value
        console.log('Updated Preference', found)
      } else {
        data.changed = true
        this.preferences.push(data)
        console.log('Added to Preferences', data)
      }
    },
    updatePreference(data) {
      let found = false
      if (this.preferences.length > 0) {
        for (let i = 0; i < this.preferences.length; i++) {
          if (this.preferences[i].type === data.type && parseInt(this.preferences[i].firm) === parseInt(data.firm)) {
            if (this.preferences[i].name === data.name) {
              if (data.isInactive !== undefined && data.isInactive !== null) {
                this.preferences[i].isInactive = data.isInactive
              } else {
                this.preferences[i].value = data.value
              }
              this.preferences[i].changed = true
              found = true
              break
            }
          }
        }
      }
      if (found === false) {
        data.changed = true
        this.preferences.push(data)
      }
    },
    async savePreferences() {
      if (this.preferences) {
        this.preferences.forEach((element) => {
          if (element.changed) {
            let data = {
              firm: element.firm,
              firmPreferenceName: element.name,
              preference: element.value.toString(),
              firmPreferenceCategory: element.type,
              isInactive: element.isInactive ? 1 : 0
            }
            api.post('firm/savePreference', data)
          }
        })
        if (this.preferences.length > 0) {
          for (let i = 0; i < this.preferences.length; i++) {
            this.preferences[i].changed = false
          }
        }
      }
    },
    async createStripeCustomer(firm) {
      let results = null
      this.stripeCustomer = null
      if (firm) {
        results = await api.post(`stripe/customer?firm=${firm}`)
      }
      console.log('Created Stripe Customer', results)
      if (results) {
        this.stripeCustomer = results
        this.location.customerId = results.id
      }
      return this.stripeCustomer
    },
    async getStripeCustomer(id) {
      this.stripeCustomer = null
      if (id) {
        this.stripeCustomer = await api.get(`stripe/customer?id=${id}`)
      }
      console.log('Got Stripe Customer', this.stripeCustomer)
      return this.stripeCustomer
    },
    async getStripeSubscriptions(id) {
      this.stripeSubscriptions = null
      if (id) {
        this.stripeSubscriptions = await api.get(`stripe/subscriptions?id=${id}`)
      }
      console.log('Got Stripe Subscriptions', this.stripeSubscriptions)
      return this.stripeSubscriptions
    },
    async getStripeInvoices(data) {
      this.stripeInvoices = null
      this.stripeInvoices = await api.get(
        `stripe/invoices?id=${data.id}&pageSize=${data.pageSize}&monthsAgo=${data.monthsAgo}&startingAfter=${data.startingAfter}`
      )
      console.log('Got Stripe Invoices', this.stripeInvoices)
      return this.stripeInvoices
    },
    async getInvoiceReport(url) {
      this.stripeInvoiceReport = null
      if (url) {
        this.stripeInvoiceReport = await api.get(`stripe/invoicereport?url=${url}`)
      }
      console.log('Got Stripe Invoice Report', this.stripeInvoiceReport)
      return this.stripeInvoiceReport
    },
    async createStripeInvoice(data) {
      let results = null
      if (data) {
        results = await api.get(`stripe/createInvoice?firm=${data.firm}&startDate=${data.dateStart}&endDate=${data.dateEnd}`)
      }
      console.log('Created Stripe Invoice', results)
      return results
    },
    async createInvoice(data) {
      let results = null
      if (data) {
        results = await api.get(
          `report/invoiceStatement?firm=${data.firm}&startDate=${data.dateStart}&endDate=${data.dateEnd}&asBase64=${data.asBase64}`
        )
      }
      console.log('Created Invoice', results)
      return results
    }
  }
})
